// removed by extract-text-webpack-plugin
module.exports = {"announcement-modal-content":"announcement-modal-content","title-label":"title-label","for-label":"for-label","contents-label":"contents-label","row":"row","announcement-editor":"announcement-editor","quill":"quill","ql-container":"ql-container","content-section":"content-section","targetClass":"targetClass"};


//////////////////
// WEBPACK FOOTER
// ./src/template/Modals/Announcement/Modal.scss
// module id = kKt6
// module chunks = 0